<template>
<a class="gi-card2" :class="{'is-nolink': !data.link}" :href="data.link ? data.link : 'javascript:void(0)'" target="_blank">
  <a class="image" :class="{'is-nolink': !data.link}"><img :src="data['图片']"></a>
  <h1 v-if="data.title" class="title">{{data.title}}</h1>
  <p v-if="data.tip" class="intro">{{data.intro}}</p>
  <p v-if="data.tip" class="tip">{{data.tip}}</p>
</a>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="sass" scoped>
$title-primary: #1075d4

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

a.gi-card2:hover
  opacity: 0.8
a.is-nolink
  cursor: auto
a.is-nolink:hover
  opacity: 1
.gi-card2
  display: block
  .img
    display: block
  img
    width: 100%
  .content
    background-color: #fff
    padding: 20px
  h1
    margin-top: 15px
    font-size: 16px
    color: #000
  p
    margin-top: 5px
    font-size: 16px
  .tip
    margin-top: 20px
    font-size: 14px
</style>
